import { Fragment, type ReactNode } from "react";
import { Show } from "./show";

type MapProps<T> = {
  items: readonly T[] | undefined | null;
  keyExtractor: (item: T, index: number) => string;
  render: (item: T, index: number) => ReactNode;
  fallback?: ReactNode;
};

export function Map<T>({ items, keyExtractor, render, fallback = null }: MapProps<T>) {
  return (
    <Show when={!!items && items.length > 0} fallback={fallback}>
      <>
        {items?.map((item, index) => (
          <Fragment key={keyExtractor(item, index)}>{render(item, index)}</Fragment>
        ))}
      </>
    </Show>
  );
}
